import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const router = useNavigate();

  useEffect(() => {
    router("/");
  });
  return <></>;
};

export default NotFound;
